import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { BackToTop } from "@/components/BackToTop";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Team from "@/pages/Team";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
// import Blog from "@/pages/Blog";
import Certs from "@/pages/Certs";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services/:id" element={<ServiceDetail />} />
      <Route path="/team" element={<Team />} />
      <Route path="/about" element={<About />} />
      <Route path="/gallery" element={<Gallery />} />
      {/* Blog disabled — redirect old URLs to home so they don't render blank / soft-404 */}
      <Route path="/blog" element={<Navigate to="/" replace />} />
      <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
      <Route path="/certs" element={<Certs />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
            <BackToTop />
            <Toaster position="top-right" theme="light" richColors />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
